import { Input, Message, Toggle } from "rsuite";

function AddEdit({ _setmodel, error, model }) {
  return (
    <>
      <label>Nom:</label>
      <Input
        onChange={(designation) => {
          _setmodel((prev) => {
            return { ...prev, designation };
          });
        }}
        value={model.designation}
      />
      <br></br>
      <label style={{ marginRight: "10px" }}> Dépense</label>
      <Toggle
        defaultChecked={model.isExpense}
        onChange={(isExpense) => {
          _setmodel((prev) => {
            return { ...prev, isExpense };
          });
        }}
        value={model.isExpense}
      />{" "}
      <i style={{ color: "#999" }}>( par default le type :Recette )</i>
      <br></br>
      {error && (
        <Message showIcon type="error">
          {error}
        </Message>
      )}
    </>
  );
}

export default AddEdit;
